import { useEffect, useState } from 'react';

// Header data-health indicator: is the official alert feed working? Reads
// /api/health, which rolls up NWS status across the states this server has
// checked. "Not checked yet" is shown as such, not as healthy.

const POLL_MS = 2 * 60 * 1000;
// Official alert feeds: NWS (US) and ECCC (Canada); the worst checked feed
// sets the colour.
const LABEL = {
  current: 'Official alerts: current',
  delayed: 'Official alerts: delayed',
  unavailable: 'Official alerts: unavailable',
  unknown: 'Official alerts: not checked yet',
};
const RANK = { unavailable: 3, delayed: 2, current: 1, unknown: 0 };

export default function DataHealth() {
  const [status, setStatus] = useState(null);
  const [detail, setDetail] = useState('');

  useEffect(() => {
    let cancelled = false;
    async function poll() {
      try {
        const res = await fetch('/api/health');
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const feeds = Object.values((await res.json()).feeds ?? {});
        if (cancelled) return;
        const worst = feeds.reduce((w, f) => ((RANK[f.status] ?? 0) > (RANK[w] ?? 0) ? f.status : w), 'unknown');
        setStatus(worst);
        const bad = feeds.flatMap((f) =>
          Object.entries(f.states ?? {})
            .filter(([, s]) => s.status !== 'current')
            .map(([st, s]) => `${f.provider} ${st}: ${s.status}${s.lastError ? ` (${s.lastError})` : ''}`),
        );
        setDetail(
          bad.length ? bad.join('\n') : feeds.map((f) => `${f.provider}: ${f.statesChecked ?? 0} area(s) checked`).join('\n'),
        );
      } catch (err) {
        if (cancelled) return;
        setStatus('unavailable');
        setDetail(`Health check failed: ${err.message}`);
      }
    }
    poll();
    const id = setInterval(poll, POLL_MS);
    return () => {
      cancelled = true;
      clearInterval(id);
    };
  }, []);

  if (!status) return null;
  return (
    <span className={`feed-pill feed-${status}`} title={detail} role="status">
      {LABEL[status] ?? LABEL.unknown}
    </span>
  );
}
